import { useFieldContext } from '~/util/hooks/useFormContext';
import { FieldLabelWithError } from './FieldLabelWithError';
import type { FieldWithErrorProps } from './FieldLabelWithError';
import { cn } from '~/util';
import { useDisableFormContext } from '../DisableContext';
import { Switch } from '~/primitives/switch';

export function SwitchField({
    switchONLabel,
    switchOFFLabel,
    ...labelProps
}: {
    switchONLabel: string;
    switchOFFLabel: string;
} & FieldWithErrorProps) {
    const field = useFieldContext<boolean>();
    const disabled = useDisableFormContext();
    return (
        <FieldLabelWithError<boolean> {...labelProps}>
            <div className="flex gap-2 py-2">
                <Switch
                    disabled={disabled}
                    className={cn(disabled && 'opacity-50 cursor-not-allowed')}
                    id={field.name}
                    checked={field.state.value}
                    onCheckedChange={(checked) => {
                        field.handleChange(checked);
                    }}
                />
                <label htmlFor={field.name}>
                    {field.state.value ? switchONLabel : switchOFFLabel}
                </label>
            </div>
        </FieldLabelWithError>
    );
}
